import React from 'react'

import EditDocumentContainer from './components/edit_document_container.jsx'

const BusinessContinuityEditDocumentApp = (props) => <EditDocumentContainer meta={{ apiEndpoints: { ...props.meta.apiEndpoints } }} />

export default BusinessContinuityEditDocumentApp
